export default __webpack_public_path__ + "static/media/map-home.3f905d35.jpg";